<template>
	<AuthedLayout ref="dashboardHeader">
		<p class="dashboard-title">Learning Center</p>
		<div v-if="tenant.isRouteComingSoon('learning-center')">
			<ComingSoonPanel message="Our Learning Center is currently under construction and will be available to you soon." />
		</div>
		<div v-else>
			<div v-if="tenant.id === Tenants.ESRD || tenant.id === Tenants.TEST">
				<MoodleCourseList/>
			</div>
		</div>
	</AuthedLayout>
</template>

<script setup lang="js">
import AuthedLayout from '@/layouts/AuthedLayout.vue'
import { Tenants } from '@/models/tenants/Tenants.js'
import ComingSoonPanel from '@/components/Misc/ComingSoonPanel.vue'
import MoodleCourseList from '@/components/LearningCenter/Moodle/MoodleCourseList.vue'

const tenant = Tenants.getTenant()
</script>

<style scoped>
</style>